import { useState } from "react";
import { Box, TextField, Typography } from "@mui/material";
import { LoadingButton } from "@mui/lab";
import { supabase } from "../../supabase";
import NotificationService from "../../components/notification/NotificationService";
import {
  textFieldStyles,
  textFieldInputLabelProps,
  buttonStyles,
} from "../../styles/theme";

export default function ResetPassword() {
  const [password, setPassword] = useState("");
  const [loading, setLoading] = useState(false);

  async function updatePassword() {
    if (!password) {
      NotificationService.showToast({
        text: "Please enter a new password",
        severity: "warning",
        duration: 3000,
      });
      return;
    }

    setLoading(true);
    try {
      const { data, error } = await supabase.auth.updateUser({
        password
      });

      if (error) {
        console.error(error);
        NotificationService.showToast({
          text: error.message,
          severity: "error",
          duration: 3000,
        });
      } else {
        NotificationService.showToast({
          text: "Password updated! You can now log in.",
          severity: "success",
          duration: 5000,
        });
        setPassword("");
      }
    } catch (e) {
      console.error(e);
    } finally {
      setLoading(false);
    }
  }

  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        alignItems: "center",
        justifyContent: "center",
        minHeight: "100vh",
        padding: 3,
        backgroundColor: "#000000",
      }}
    >
      <Box
        sx={{
          maxWidth: 400,
          width: "100%",
          padding: 4,
          backgroundColor: "#141414",
          borderRadius: "10px",
          border: "1px solid #3c3c3c",
        }}
      >
        <Typography variant="h5" sx={{ color: "#ff6b00", mb: 2, textAlign: "center", fontWeight: "bold" }}>
          Reset Your Password
        </Typography>
        <Typography variant="body2" sx={{ color: "#b9b9ba", mb: 3, textAlign: "center" }}>
          Enter your new password below.
        </Typography>

        <TextField
          id="password"
          sx={{ ...textFieldStyles, mb: 3 }}
          fullWidth
          value={password}
          onChange={(e) => setPassword(e.target.value)}
          label="New Password"
          variant="standard"
          type="password"
          InputLabelProps={{ style: textFieldInputLabelProps }}
        />

        <LoadingButton
          loading={loading}
          sx={{
            ...buttonStyles,
            backgroundColor: "#ff6b00",
            "&:hover": {
              backgroundColor: "#e55f00",
            },
            "&:disabled": {
              backgroundColor: "#3A3A3A",
              color: "#CDCDCD4D",
            },
          }}
          fullWidth
          variant="contained"
          onClick={updatePassword}
        >
          Update Password
        </LoadingButton>
      </Box>
    </Box>
  );
}
